import EnviarSimulacionFormulario from "./enviarSimulacionFormulario";

class EnviarSimulacionModal extends React.Component {
  constructor(props) {
    super(props);
    this.handleHide = this.handleHide.bind(this);
    this.handleShow = this.handleShow.bind(this);

    this.state = {
      showModal: false,
    };
  }

  handleHide() {
    this.setState({ showModal: false });
    this.props.showCotizador(event);
  }

  handleShow() {
    this.setState({ showModal: true });
  }

  render() {
    return (
      <div id="modal-wrap">
        <div className="modal-container">
          <Modal
            show={this.state.showModal}
            container={this.props.container}
            onHide={this.handleHide}
            bsSize="large"
            backdrop="static"
            aria-labelledby="contained-modal-title"
          >
            <Modal.Header>
              <button
                id="close-modal"
                type="button"
                className="close-button"
                onClick={this.handleHide}
              >
                <i className="fa fa-times"></i>
              </button>
            </Modal.Header>
            <Modal.Body>
              <EnviarSimulacionFormulario
                handleHide={this.handleHide}
                configurations={this.props.configurations}
                form={this.props.form}
                subscribed={this.props.subscribed}
                summary={this.props.summary}
                planvital={this.props.planvital}
                precio={this.props.precio}
              />
            </Modal.Body>
          </Modal>
        </div>
      </div>
    );
  }
}

/******************** BUILD ********************/
const Modal = ReactBootstrap.Modal;
/******************** BUILD ********************/

export default EnviarSimulacionModal;
